import { jsx as _jsx } from "react/jsx-runtime";
import { Visibility as VisibilityIcon } from "@mui/icons-material";
import { VisibilityOff as VisibilityOffIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
export function VisibilityIndicatorIcon({ isVisible, color = "disabled", fontSize, padding, }) {
    return (_jsx(Box, { padding: padding ?? "4px" // TODO: can we get IconButton size=small padding somehow from theme?
        , display: "flex", children: isVisible ? (_jsx(VisibilityIcon, { color: color, fontSize: fontSize })) : (_jsx(VisibilityOffIcon, { color: color, fontSize: fontSize })) }));
}
//# sourceMappingURL=VisibilityIndicatorIcon.js.map